// Get List
export const GET_LIST_QUARTERTARIFF = "GET_LIST_QUARTERTARIFF"
export const GET_LIST_QUARTERTARIFF_SUCCESS = "GET_LIST_QUARTERTARIFF_SUCCESS"
export const GET_LIST_QUARTERTARIFF_FAIL = "GET_LIST_QUARTERTARIFF_FAIL"

// Upsert (Create/Update)
export const UPSERT_QUARTERTARIFF = "UPSERT_QUARTERTARIFF"
export const UPSERT_QUARTERTARIFF_SUCCESS = "UPSERT_QUARTERTARIFF_SUCCESS"
export const UPSERT_QUARTERTARIFF_FAIL = "UPSERT_QUARTERTARIFF_FAIL"

// Delete
export const DELETE_QUARTERTARIFF = "DELETE_QUARTERTARIFF"
export const DELETE_QUARTERTARIFF_SUCCESS = "DELETE_QUARTERTARIFF_SUCCESS"
export const DELETE_QUARTERTARIFF_FAIL = "DELETE_QUARTERTARIFF_FAIL"

// Reset Messages
export const RESET_QUARTERTARIFF_MESSAGES = "RESET_QUARTERTARIFF_MESSAGES"